<template>
  <el-container id="adb">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background: #F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px"> {{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-aside width="260px" style="display:flex;background:#FFFFFF">
        <div style="height:100%;position:relative;overflow: hidden;">
          <el-input
              style="margin:15px;width:auto;height:auto"
              placeholder="请输入分组名称"
              prefix-icon="el-icon-search"
              v-model="scan_db_name">
          </el-input>
          <ul class="left_main">
            <li v-for="(g,index) in filteredItems" :key="g.id" style="height:40px;margin-left:8px;margin-right:8px;"
                @click="btnClick(index)" :class="{active:currentIndex === index}">
              <div style="display:flex;width:auto;height:40px;line-height:0.4">
                <p style="width:50%;text-align:left;margin-left:7px;">{{ g.name }}</p>
                <p style="width:50%;text-align:right;margin-right:7px;">{{ g.sum }} 个</p>
              </div>
            </li>
          </ul>
          <div class="left_footer">
            <el-divider></el-divider>
            <div style="height:50px;display:flex;justify-content:center;align-items:center;">
              <i class="el-icon-plus" style="color: #134FC2;"></i>
              <p style="margin-left:10px;margin-right:10px;font-size:15px;color:#134FC2;">新增分组</p>
            </div>
          </div>
        </div>
      </el-aside>
      <el-container style="padding-left:15px">
        <el-header height="120px" class="div_right_head">
          <div style="height:20%;width:100%;display:flex;align-items:center;">
            <p style="font-weight: bold;">一层空调</p>
            <i class="el-icon-edit" style="margin-left:10px"></i>
            <el-button size="small" style="color:red;margin-left:auto;">删除设备</el-button>
          </div>
          <div class="right_head_dev">
            <div style="margin:15px;line-height:0.4;text-align: left">
              <p style="font-weight:bold;color:#414449">电表01</p>
              <p>00:00:01:01:02</p>
            </div>
            <div style="margin-left:auto;display: flex;">
              <p style="margin:15px;font-weight:bold;color:#414449">累计电量</p>
              <p style="margin:15px;font-size:20px;color:#1447A8">22 kWh</p>
            </div>
          </div>
        </el-header>
        <el-main class="div_right_main" style="margin-top: 15px;">
          <div style="display:flex;height:36px;width:100%;line-height:0.3;text-align:left;align-items: center;">
            <p style="width:100px;font-size:18px;font-weight:bold;">组内设备</p>
            <el-button size="small" type="primary" style="margin-left:auto">添加设备</el-button>
            <el-button size="small" style="color:red;margin-right:0">删除设备</el-button>
          </div>
          <el-table :data=tableData class="tab_adb" :cell-style="tableYs"
                    style="width:100%; font-size:13px; background:#F4F4F4;margin-top:10px"
                    :max-height=maxHeight show-overflow-tooltip :row-key="rowKey"
                    :header-cell-style="{'text-align':'center','background':'#F4F4F4','color':'#0dA7C8'}">
            <el-table-column
                type="selection"
                :reserve-selection="true"
                width="60">
            </el-table-column>
            <el-table-column v-for="(d,item) in this.defHead" :key=item
                             :prop=d.val :label=d.key :width="d.w" sortable>
            </el-table-column>
          </el-table>
          <el-pagination
              style="float:right; margin-right:0.5vw;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange1"
              :current-page="currentPage"
              :page-sizes="[20, 40, 80, 160, 320]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
        </el-main>
        <el-footer style="margin-bottom: 1px;height:1px">
        </el-footer> <!--grid加底部去除遮挡-->
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name:"adb",
  data() {
    return {
      pageSize:20,
      currentPage:1,
      h_text:"电表分组",
      li_h_text:[
        {"text":"节能统计","colour":"#B7B7B7","pages":""}
      ],
      defHead:[
        {'key':"序号",'val':"item","w":"auto"},
        {'key':"设备类型",'val':"dev_type","w":"auto"},
        {'key':"设备名称",'val':"dev_name","w":"auto"},
        {'key':"Mac",'val':"dev_mac","w":"auto"},
        {'key':"状态",'val':"dev_status","w":"auto"}
      ],
      tableData:[
        {'item':"1",'dev_type':"item","dev_name":"auto"},
        {'item':"1",'dev_type':"item","dev_name":"auto"},
        {'item':"1",'dev_type':"item","dev_name":"auto"},
        {'item':"1",'dev_type':"item","dev_name":"auto"},
        {'item':"1",'dev_type':"item","dev_name":"auto"},
        {'item':"1",'dev_type':"item","dev_name":"auto"},
        {'item':"1",'dev_type':"item","dev_name":"auto"},
        {'item':"1",'dev_type':"item","dev_name":"auto"},
        {'item':"1",'dev_type':"item","dev_name":"auto"},
        {'item':"1",'dev_type':"item","dev_name":"auto"},
        {'item':"1",'dev_type':"item","dev_name":"auto"},
        {'item':"1",'dev_type':"item","dev_name":"auto"},
        {'item':"1",'dev_type':"item","dev_name":"auto"},
        {'item':"1",'dev_type':"item","dev_name":"auto"},
        {'item':"1",'dev_type':"item","dev_name":"auto"},
        {'item':"1",'dev_type':"item","dev_name":"auto"},
        {'item':"1",'dev_type':"item","dev_name":"auto"},
        {'item':"1",'dev_type':"item","dev_name":"auto"},
        {'item':"1",'dev_type':"item","dev_name":"auto"},
        {'item':"1",'dev_type':"item","dev_name":"auto"},
        {'item':"1",'dev_type':"item","dev_name":"auto"},
        {'item':"1",'dev_type':"item","dev_name":"auto"}
      ],
      maxHeight:window.innerHeight - 370,
      scan_db_name:"",
      li_db_group:[ /*电表分组列表*/
        {id:1,name:"12",sum:12},
        {id:2,name:"12",sum:12},
        {id:3,name:"12",sum:12},
        {id:4,name:"12",sum:12},
        {id:5,name:"12",sum:12},
        {id:6,name:"12",sum:12},
        {id:7,name:"12",sum:12},
        {id:8,name:"12",sum:12},
        {id:9,name:"12",sum:12},
        {id:10,name:"12",sum:12}
      ],
      currentIndex:0
    };
  },
  computed:{ /*定义计算属性-响应数据改变后重新计算*/
    filteredItems() {
      return this.li_db_group.filter(item => {
        console.log(item.name);
        return item.name.toLowerCase().includes(this.scan_db_name.toLowerCase());
      });
    },
    total() {
      return this.tableData.length;
    }
  },
  watch:{  /*监听参数变化*/

  },
  methods:{ /*方法存放*/
    btnClick(index) {
      this.currentIndex = index;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.init_View();
    },
    handleCurrentChange1(val) {
      this.currentPage = val;
      this.init_View();
    },
    rowKey(row) {
      return row.id;
    },
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    change_dvc(row) {
      console.log(row);
      this.floor_id = row.floor_id;
      this.floor_name = row.floor_name;
      this.floor_bz = row.floor_bz;
      this.d_type = "change";
      this.dailogShow = true;
    },
    del_dvc(row) {
      if (parseInt(localStorage.getItem('kt_qx')) === 0) {
        this.floor_id = row.floor_id;
        this.dialogVisible = true;
      } else {
        this.$message.error("删除需要管理员权限");
      }
    },
    init_View() {

    }
  },
  mounted() { /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip");
  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#adb {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #F4F4F4;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}

.left_main {
  padding: 0;
  margin: 0;
  height: 70vh;
  list-style-type: none;
  overflow-y: auto;
}

::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
}

::-webkit-scrollbar-thumb {
  border-radius: 10px; /* 滚动条圆角 */
  background-color: #0dA7C8; /* 滚动条颜色 */
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #cacaca;
  border: 1px solid #cacaca;
}


.left_footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 50px;
  text-align: center;
  padding: 10px 0;
  line-height: 0.3;
}

.div_right_head {
  margin: 0;
  padding: 15px;
  width: 100%;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: start;
  background: #FFFFFF;
}

.right_head_dev {
  height: 70%;
  display: flex;
  align-items: center;
  background: #ECF2FE;
  margin-top: 15px;
  border-radius: 5px 5px 5px 5px;
}

.div_right_main {
  padding: 15px;
  background: #FFFFFF;
}

.active {
  background: #E7F0FF;
  color: #134FC2;
  border-radius: 6px 6px 6px 6px;
}

.tab_adb {
  user-select: text;

  .gutter { /*去除表格右边留白*/
    background-color: #FFFFFF !important;
    border: 5px solid #FFFFFF !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
    }
  }

  .el-table__body-wrapper {
    overflow-y: auto;
    background: #FFFFFF;
    height: calc(100% - 66px) !important; /*去除表格底部留白*/
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #0dA7C8;
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #cacaca;
    border: 1px solid #cacaca;
  }
}

.el-divider--horizontal { /*分割线样式*/
  margin: 0px 0% 0% 0%; /*上 右 下 左*/
  width: 100%;
  background: #F2F2F2;
}
</style>



// WEBPACK FOOTER //
// src/pages/gls/glDb.vue